<template>
  <div class="payment-change-info">
    <span>
      If you want to change your payment method please make a payment on the
      right side. </span
    ><br />
    <span>
      To validate your billing method we will make a 1.00 € plus VAT. payment. </span
    ><br />
    <span>
      The amount cannot be refunded afterwards.
    </span>
  </div>
</template>

<script>
export default {
  name: "payment-change-info-view",
  props: {},
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.payment-change-info {
  margin-top: 50px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e7e7e7;
  padding: 15px;
  border-radius: 5px;
}
</style>
